import { render, staticRenderFns } from "./user-management-user-form.vue?vue&type=template&id=511832e4"
import script from "./user-management-user-form.vue?vue&type=script&lang=js"
export * from "./user-management-user-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports